module.exports = __webpack_public_path__ + "static/media/storeIcons.d2c80597.svg";